import React from "react";
import PropTypes from "prop-types";

import Divider from "@material-ui/core/Divider/Divider";

import { SCService, API_URL_BASE } from "../../../API/server_calls.js";

import TDrawerHeader from "../../../Library/Drawers/TDrawerHeader";
import TButton from "../../../Library/Buttons/TButton";
import TDialog from "../../../Library/Dialogs/TDialog";
import TRadioGroup from "../../../Library/RadioGroups/TRadioGroup";
import TWifiAnimation from "../../../Library/OtherComponents/TWifiAnimation";
import TTabs2 from "../../../Library/Tabs/TTabs2";

import * as GBConst from "../../GB/NonComponents/GBConst";
import { shouldComponentUpdateGB } from "../../GB/NonComponents/GBUtil";

import SCCharacteristicComboBoxes from "../OtherComponents/SCCharacteristicComboBoxes";
import SCTargetTable from "../Tables/SCTargetTable";
import SCPersFacTable from "../Tables/SCPersFacTable";
import SCProductivityTable from "../Tables/SCProductivityTable";
import SCDemandTable from "../Tables/SCDemandTable";
import SCComboBoxProvinces from "../ComboBoxes/SCComboBoxProvinces";
import SCComboBoxSNUs from "../ComboBoxes/SCComboBoxSNUs";
import SCComboBoxSites from "../ComboBoxes/SCComboBoxSites";
import SCComboBoxMonths from "../ComboBoxes/SCComboBoxMonths";
import { getInputValue, getMonthName, formatTimeAmPm } from "../NonComponents/SCUtil.js";
import {
    getIndicatorName,
    getIndicatorNumItems,
    getCategoryName,
    getFirstSiteIndices,
    getCountryObj,
    getSiteCurrID,
    getSiteMstID,
    getIndicatorNoDataValue,
} from "../NonComponents/SCDataUtil.js";
import * as SCConst from "../NonComponents/SCConst.js";
import SCLocationsSelector from "../OtherComponents/SCLocationsSelector";

/* These constants should never be necessary outside of this unit. If this changes, move them to
   SCConst. */
const dataEntryOptionStr = "dataEntryOption";

const dataEntryOnlineNum = 1;
const dataEntryOfflineNum = 2;

class SCDataEntryDrawer extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        countryObjList: PropTypes.array,
        selectedCountryCode: PropTypes.number,
        indInfo: PropTypes.object,
        catInfo: PropTypes.object,
        mstIDsObj: PropTypes.object,
        siteCharByTimeInfo: PropTypes.object,
        mostRecentYearRangesArray: PropTypes.array,
        config: PropTypes.object,
        configExtra: PropTypes.object,
        siteInfo: PropTypes.object,
        onSave: PropTypes.func,
        onClose: PropTypes.func,
    };

    static defaultProps = {
        countryObjList: [],
        selectedCountryCode: 0,
        indInfo: null,
        catInfo: null,
        mstIDsObj: null,
        siteCharByTimeInfo: null,
        mostRecentYearRangesArray: [],
        config: null,
        configExtra: null,
        siteInfo: null,
        onSave: () => console.log("onSave"),
        onClose: () => console.log("onClose"),
    };

    constructor(props) {
        super(props);

        const indInfo = this.props.indInfo;
        const mstIDsObj = this.props.mstIDsObj;
        const countryObjList = this.props.countryObjList;
        const selectedCountryCode = this.props.selectedCountryCode;

        const countryObj = getCountryObj(countryObjList, selectedCountryCode);

        this.state = {
            loading: true,

            countryObj: countryObj,

            dataEntryOption: dataEntryOnlineNum,

            dateInfo: [],
            dateNames: [],

            dateIdx: 0,

            downloadingTemplateBool: false,

            provinceIdx: getFirstSiteIndices(countryObj)[0],
            snuIdx: getFirstSiteIndices(countryObj)[1],
            siteIdx: getFirstSiteIndices(countryObj)[2],

            GeoIdx: 0,
            ServiceDeliveryModesIdx: 0,
            PEPFARCategoriesIdx: 0,
            VMMCCategoriesIdx: 0,
            DREAMSIdx: 0,
            USGAgenciesIdx: 0,
            ImplementingPartnersIdx: 0,
            OwnershipIdx: 0,
            moveIdx: 0,
            taskShiftingIdx: 0,

            target: [
                ["", "Month"],
                [getIndicatorName(SCConst.targNumCircumIndMstID, indInfo, mstIDsObj), 1],
            ],

            targetIndItemMstIDs: [
                ["", ""],
                [SCConst.targNumCircumIndMstID, ""],
            ],

            persFac: [
                ["", "Value"],
                [getIndicatorName(SCConst.numSurgBedsIndMstID, indInfo, mstIDsObj), 1],
                [getIndicatorName(SCConst.currNumProvidersIndMstID, indInfo, mstIDsObj), 2],
                [getIndicatorName(SCConst.currNumAssistantsIndMstID, indInfo, mstIDsObj), 3],
                [getIndicatorName(SCConst.currNumNursesIndMstID, indInfo, mstIDsObj), 4],
                [getIndicatorName(SCConst.currNumMobilIndMstID, indInfo, mstIDsObj), 5],
                [getIndicatorName(SCConst.currNumCounsIndMstID, indInfo, mstIDsObj), 6],
            ],

            persFacIndItemMstIDs: [
                ["", ""],
                [SCConst.numSurgBedsIndMstID, ""],
                [SCConst.currNumProvidersIndMstID, ""],
                [SCConst.currNumAssistantsIndMstID, ""],
                [SCConst.currNumNursesIndMstID, ""],
                [SCConst.currNumMobilIndMstID, ""],
                [SCConst.currNumCounsIndMstID, ""],
            ],

            VMMCsPerformed: [
                ["", "", "Month"],
                [getIndicatorName(SCConst.VMMC_DoneIndMstID, indInfo, mstIDsObj), "< 1", 1],
                ["", "1-4", 2],
                ["", "5-9", 3],
                ["", "10-14", 4],
                ["", "15-19", 5],
                ["", "20-24", 6],
                ["", "25-29", 7],
                ["", "30-34", 8],
                ["", "35-39", 9],
                ["", "40-44", 10],
                ["", "45-49", 11],
                ["", "50+", 12],
                ["", "Total", 13],
                [getIndicatorName(SCConst.daysOfOpIndMstID, indInfo, mstIDsObj), "", 14],
                [getIndicatorName(SCConst.followUpIndMstID, indInfo, mstIDsObj), "48 hours", 15],
                ["", "7 days", 16],
                ["", "6 weeks", 17],
                [getIndicatorName(SCConst.adverseEventsIndMstID, indInfo, mstIDsObj), "Mild", 18],
                ["", "Moderate", 19],
                ["", "Severe", 20],
                ["STI (VMMC clients only)", getIndicatorName(SCConst.STIPosIndMstID, indInfo, mstIDsObj), 21],
                ["", getIndicatorName(SCConst.STITreatCircumIndMstID, indInfo, mstIDsObj), 22],
                [
                    "HIV testing (VMMC clients only)",
                    getIndicatorName(SCConst.HIVTestDoneIndMstID, indInfo, mstIDsObj),
                    23,
                ],
                ["", getIndicatorName(SCConst.HIVPosIndMstID, indInfo, mstIDsObj), 24],
                ["", getIndicatorName(SCConst.enrolledCAndTIndMstID, indInfo, mstIDsObj), 25],
            ],

            VMMCsPerformedIndItemMstIDs: [
                ["", ""],
                [SCConst.VMMC_DoneIndMstID, SCConst.ageLT2MoMstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age1t4MstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age5t9MstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age10t14MstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age15t19MstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age20t24MstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age25t29MstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age30t34MstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age35t39MstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age40t44MstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age45t49MstID],
                [SCConst.VMMC_DoneIndMstID, SCConst.age50PlusMstID],
                ["", ""],
                [SCConst.daysOfOpIndMstID, ""],
                [SCConst.followUpIndMstID, SCConst.period48HrsMstID],
                [SCConst.followUpIndMstID, SCConst.period7DaysMstID],
                [SCConst.followUpIndMstID, SCConst.period6WeeksMstID],
                [SCConst.adverseEventsIndMstID, SCConst.mildMstID],
                [SCConst.adverseEventsIndMstID, SCConst.moderateMstID],
                [SCConst.adverseEventsIndMstID, SCConst.severeMstID],
                [SCConst.STIPosIndMstID, ""],
                [SCConst.STITreatCircumIndMstID, ""],
                [SCConst.HIVTestDoneIndMstID, ""],
                [SCConst.HIVPosIndMstID, ""],
                [SCConst.enrolledCAndTIndMstID, ""],
            ],

            demand: [
                ["", "", "Month"],
                [getIndicatorName(SCConst.numReachedByMobilIndMstID, indInfo, mstIDsObj), "< 1", 1],
                ["", "1-4", 2],
                ["", "5-9", 3],
                ["", "10-14", 4],
                ["", "15-19", 5],
                ["", "20-24", 6],
                ["", "25-29", 7],
                ["", "30-34", 8],
                ["", "35-39", 9],
                ["", "40-44", 10],
                ["", "45-49", 11],
                ["", "50+", 12],
                ["", "Total", 13],
                [getIndicatorName(SCConst.numSeekingVMMC_ServIndMstID, indInfo, mstIDsObj), "< 1", 14],
                ["", "1-4", 15],
                ["", "5-9", 16],
                ["", "10-14", 17],
                ["", "15-19", 18],
                ["", "20-24", 19],
                ["", "25-29", 20],
                ["", "30-34", 21],
                ["", "35-39", 22],
                ["", "40-44", 23],
                ["", "45-49", 24],
                ["", "50+", 25],
                ["", "Total", 26],
                ["Number of people reached through", "TV", 27],
                //[getIndicatorName(SCConst.infoSourcesIndMstID, indInfo, mstIDsObj), "TV", 25],
                ["", "Radio", 28],
                ["", "Friend", 29],
                ["", "Family", 30],
                ["", "Mobilisers", 31],
                ["", "Community leaders", 32],
                ["", "Posters", 33],
                ["", "Health workers", 34],
                ["", "Total", 35],
            ],

            demandIndItemMstIDs: [
                ["", ""],
                [SCConst.numReachedByMobilIndMstID, SCConst.ageLT2MoMstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age1t4MstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age5t9MstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age10t14MstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age15t19MstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age20t24MstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age25t29MstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age30t34MstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age35t39MstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age40t44MstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age45t49MstID],
                [SCConst.numReachedByMobilIndMstID, SCConst.age50PlusMstID],
                ["", ""],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.ageLT2MoMstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age1t4MstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age5t9MstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age10t14MstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age15t19MstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age20t24MstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age25t29MstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age30t34MstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age35t39MstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age40t44MstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age45t49MstID],
                [SCConst.numSeekingVMMC_ServIndMstID, SCConst.age50PlusMstID],
                ["", ""],
                [SCConst.infoSourcesIndMstID, SCConst.TVMstID],
                [SCConst.infoSourcesIndMstID, SCConst.radioMstID],
                [SCConst.infoSourcesIndMstID, SCConst.friendMstID],
                [SCConst.infoSourcesIndMstID, SCConst.familyMstID],
                [SCConst.infoSourcesIndMstID, SCConst.mobilisersMstID],
                [SCConst.infoSourcesIndMstID, SCConst.communityLeadersMstID],
                [SCConst.infoSourcesIndMstID, SCConst.postersMstID],
                [SCConst.infoSourcesIndMstID, SCConst.healthWorkersMstID],
                ["", ""],
            ],
        };
    }

    componentDidMount() {
        this.setDates(() => {
            this.getSiteData();

            this.setState({
                loading: false,
            });
        });
    }

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). Ping in App will
       cause rendering to keep happening unless we do this. */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    setDates = (successFn, errorFn) => {
        try {
            const mostRecentYearRangesArray = this.props.mostRecentYearRangesArray;
            const mstIDsObj = this.props.mstIDsObj;

            const countryObj = this.state.countryObj;
            const provinceIdx = this.state.provinceIdx;
            const SNU_Idx = this.state.snuIdx;
            const siteIdx = this.state.siteIdx;

            const siteMstID = getSiteMstID(countryObj, provinceIdx, SNU_Idx, siteIdx);
            const siteCurrID = getSiteCurrID(siteMstID, mstIDsObj);

            if (siteCurrID > 0) {
                /* Changing the site will change the range of months the user can select, so update state
                   related to dates first based upon the newly selected site. */
                //const startMonth = mostRecentYearRangesArray[siteCurrID][SCConst.startMonth];
                const startYear = mostRecentYearRangesArray[siteCurrID][SCConst.startYear];
                //const endMonth = mostRecentYearRangesArray[siteCurrID][SCConst.endMonth];
                const endYear = mostRecentYearRangesArray[siteCurrID][SCConst.endYear];
                const monthsForYear = mostRecentYearRangesArray[siteCurrID][SCConst.monthsForYear];

                let monthArr = [
                    "",
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ];

                let dateNames = [];
                let dateInfo = [];

                let yrIdx = 1;
                for (let yr = startYear; yr <= endYear; yr++) {
                    let m1 = monthsForYear[yrIdx][SCConst.firstMonthLoop];
                    let m2 = monthsForYear[yrIdx][SCConst.finalMonthLoop];
                    for (let m = m1; m <= m2; m++) {
                        let monthName = monthArr[m];
                        dateNames.push(monthArr[m] + " " + yr);
                        dateInfo.push({
                            month: monthName,
                            year: yr,
                            monthIdx: m,
                            yearIdx: yr - SCConst.firstPossibleYear + 1,
                        });
                    }
                    yrIdx++;
                }

                dateNames.reverse();
                dateInfo.reverse();

                this.setState(
                    {
                        dateNames: dateNames,
                        dateInfo: dateInfo,
                        dateIdx: 0,
                    },
                    successFn
                );
            } else {
                this.setState(
                    {
                        dateNames: [],
                        dateInfo: [],
                        dateIdx: 0,
                    },
                    successFn
                );
            }
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onProvinceChange = (value, text, info) => {
        try {
            /* If the site changes, the available months need to change too. */
            this.setState(
                {
                    provinceIdx: value,
                    snuIdx: 0,
                    siteIdx: 0,
                },
                () => {
                    this.setDates(() => {
                        this.getSiteData();
                    });
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onSNUChange = (value, text, info) => {
        try {
            /* If the site changes, the available months need to change too. */
            this.setState(
                {
                    snuIdx: value,
                    siteIdx: 0,
                },
                () => {
                    this.setDates(() => {
                        this.getSiteData();
                    });
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onSiteChange = (value, text, info) => {
        try {
            /* If the site changes, the available months need to change too. */
            this.setState(
                {
                    siteIdx: value,
                },
                () => {
                    this.setDates(() => {
                        this.getSiteData();
                    });
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onDateChange = (value, text, info) => {
        try {
            this.setState(
                {
                    dateIdx: value,
                },
                () => this.getSiteData()
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //--------------------------------------------

    onGeoChange = (value) => {
        try {
            this.setState({
                GeoIdx: value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onPEPFARCategoriesChange = (value) => {
        try {
            this.setState({
                PEPFARCategoriesIdx: value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onVMMCCategoriesChange = (value) => {
        try {
            this.setState({
                VMMCCategoriesIdx: value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onDREAMSChange = (value) => {
        try {
            this.setState({
                DREAMSIdx: value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onUSGAgencieChange = (value) => {
        try {
            this.setState({
                USGAgenciesIdx: value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onImplementingPartnersChange = (value) => {
        try {
            this.setState({
                ImplementingPartnersIdx: value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onServiceDeliveryModesChange = (value) => {
        try {
            this.setState({
                ServiceDeliveryModesIdx: value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onOwnershipChange = (value) => {
        try {
            this.setState({
                OwnershipIdx: value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onMoveChange = (value) => {
        try {
            this.setState({
                moveIdx: value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onTaskShiftingChange = (value) => {
        try {
            this.setState({
                taskShiftingIdx: value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //--------------------------------------------

    onTargetsChange = (hot, packTable) => {
        this.setState({
            target: packTable.tableData.value,
        });

        try {
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onCapacityChange = (hot, packTable) => {
        try {
            this.setState({
                persFac: packTable.tableData.value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onVMMCDoneChange = (hot, packTable) => {
        try {
            this.setState({
                VMMCsPerformed: packTable.tableData.value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onDemandChange = (hot, packTable) => {
        try {
            this.setState({
                demand: packTable.tableData.value,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //--------------------------------------------

    onClose = () => {
        try {
            this.props.onClose();
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    getSiteData = () => {
        try {
            const indInfo = this.props.indInfo;
            const mstIDsObj = this.props.mstIDsObj;

            const provinceIdx = this.state.provinceIdx;
            const SNU_Idx = this.state.snuIdx;
            const siteIdx = this.state.siteIdx;
            let countryObj = this.state.countryObj;

            const siteMstID = getSiteMstID(countryObj, provinceIdx, SNU_Idx, siteIdx);

            const setSiteState = (response) => {
                const dateIdx = this.state.dateIdx;
                const dateInfo = this.state.dateInfo;

                let monthIdx = dateInfo[dateIdx].monthIdx;
                let yearIdx = dateInfo[dateIdx].yearIdx;

                let monthName = dateInfo[dateIdx].month;
                let yearName = dateInfo[dateIdx].year;
                let monthToDisplay = monthName + " " + yearName;

                /* Find each of the relevant pieces of data by yearIdx and month. */

                const getValue = (indMstID, objList, yearIdx, monthIdx, extraDim) => {
                    let value = getIndicatorNoDataValue(indMstID, indInfo, mstIDsObj);

                    if (objList.length > 0) {
                        for (let i = 1; i <= objList.length; i++) {
                            const dataObj = objList[i - 1];

                            if (dataObj[SCConst.yearIdxDO] === yearIdx && dataObj[SCConst.monthDO] === monthIdx) {
                                if (typeof extraDim === "undefined" || dataObj[SCConst.extraDimDO] === extraDim) {
                                    value = dataObj[SCConst.valueDO];
                                }
                            }
                        }
                    }

                    return value;
                };

                const getArrayOfValues = (indMstID, objList, numItems, yearIdx, monthIdx, extraDim) => {
                    let valueArray = [];
                    valueArray.length = numItems + 1;
                    valueArray.fill(getIndicatorNoDataValue(indMstID, indInfo, mstIDsObj));

                    if (objList.length > 0) {
                        for (let i = 1; i <= objList.length; i++) {
                            const dataObj = objList[i - 1];

                            if (
                                dataObj[SCConst.yearIdxDO] === yearIdx &&
                                dataObj[SCConst.monthDO] === monthIdx &&
                                dataObj[SCConst.extraDimDO] === extraDim
                            ) {
                                valueArray = dataObj[SCConst.valueDO];
                            }
                        }
                    }

                    return valueArray;
                };

                /* Holds all data for a site for a given month and year. */
                let siteObj = {
                    setup: {
                        numYears: response.fNumYears,
                        model: response.fModel,

                        provCurrID: response.fProvCurrID,
                        SNU_CurrID: response.fSNU_CurrID,

                        siteMstID: response.fSiteMstID,
                        siteName: response.fSiteName,

                        geoType: response.fGeoType,
                        servDelivMode: response.fServDelivMode,
                        openingMonth: response.sOpeningMonth,
                        openingYear: response.sOpeningYear,
                        openingDate: response.fOpeningDate,
                        closed: response.fClosed,
                        closingDate: response.fClosingDate,
                    },

                    characteristics: {
                        ownershipType: getValue(
                            SCConst.ownershipTypeIndMstID,
                            response.ownershipTypeObjList,
                            yearIdx,
                            monthIdx
                        ),

                        PEPFAR_Cat: getValue(SCConst.PEPFAR_CatIndMstID, response.PEPFAR_CatObjList, yearIdx, monthIdx),

                        VMMC_Cat: getValue(SCConst.VMMC_CatIndMstID, response.VMMC_CatObjList, yearIdx, monthIdx),

                        DREAMS_Cat: getValue(SCConst.DREAMS_CatIndMstID, response.DREAMS_CatObjList, yearIdx, monthIdx),

                        USG_Agency: getValue(SCConst.USG_AgencyIndMstID, response.USG_AgencyObjList, yearIdx, monthIdx),

                        impPartner: getValue(SCConst.impPartnerIndMstID, response.impPartnerObjList, yearIdx, monthIdx),

                        taskShiftServDeliv: getValue(
                            SCConst.taskShiftServDelivIndMstID,
                            response.taskShiftServDelivObjList,
                            yearIdx,
                            monthIdx
                        ),

                        moveServDeliv: getValue(
                            SCConst.moveServDelivIndMstID,
                            response.moveServDelivObjList,
                            yearIdx,
                            monthIdx
                        ),
                    },

                    personnel: {
                        numSurgBeds: getValue(
                            SCConst.numSurgBedsIndMstID,
                            response.numSurgBedsObjList,
                            yearIdx,
                            monthIdx
                        ),

                        /* These three indicators (current number of providers, assistants, nurses) are unique because
                           they share space in the same variable even though they are treated as three different
                           indicators. Therefore, pass in a hardcoded 3 for now for the number of items. We can use
                           current number of providers' master ID since all three should have the same no data
                           default value. */
                        currNumSurgCapStaff: getArrayOfValues(
                            SCConst.currNumProvidersIndMstID,
                            response.currNumSurgCapStaffObjList,
                            getIndicatorNumItems(3, indInfo, mstIDsObj),
                            yearIdx,
                            monthIdx
                        ),

                        currNumCouns: getValue(
                            SCConst.currNumCounsIndMstID,
                            response.currNumCounsObjList,
                            yearIdx,
                            monthIdx
                        ),

                        daysOfOp: getValue(SCConst.daysOfOpIndMstID, response.daysOfOpObjList, yearIdx, monthIdx),
                    },

                    VMMC_ServDeliv: {
                        targNumCircum: getValue(
                            SCConst.targNumCircumIndMstID,
                            response.targNumCircumObjList,
                            yearIdx,
                            monthIdx
                        ),

                        VMMC_Done: getArrayOfValues(
                            SCConst.VMMC_DoneIndMstID,
                            response.VMMC_DoneObjList,
                            getIndicatorNumItems(SCConst.VMMC_DoneIndMstID, indInfo, mstIDsObj),
                            yearIdx,
                            monthIdx
                        ),

                        surgMethod: getArrayOfValues(
                            SCConst.surgMethodIndMstID,
                            response.surgMethodObjList,
                            getIndicatorNumItems(SCConst.surgMethodIndMstID, indInfo, mstIDsObj),
                            yearIdx,
                            monthIdx
                        ),

                        followUp: getArrayOfValues(
                            SCConst.followUpIndMstID,
                            response.followUpObjList,
                            getIndicatorNumItems(SCConst.followUpIndMstID, indInfo, mstIDsObj),
                            yearIdx,
                            monthIdx
                        ),

                        adverseEvents: getArrayOfValues(
                            SCConst.adverseEventsIndMstID,
                            response.adverseEventsObjList,
                            getIndicatorNumItems(SCConst.adverseEventsIndMstID, indInfo, mstIDsObj),
                            yearIdx,
                            monthIdx
                        ),
                    },

                    demand: {
                        currNumMobil: getValue(
                            SCConst.currNumMobilIndMstID,
                            response.currNumMobilObjList,
                            yearIdx,
                            monthIdx
                        ),

                        numReachedByMobil: getArrayOfValues(
                            SCConst.numReachedByMobilIndMstID,
                            response.numReachedByMobilObjList,
                            getIndicatorNumItems(SCConst.numReachedByMobilIndMstID, indInfo, mstIDsObj),
                            yearIdx,
                            monthIdx
                        ),

                        numSeekingVMMC_Serv: getArrayOfValues(
                            SCConst.numSeekingVMMC_ServIndMstID,
                            response.numSeekingVMMC_ServObjList,
                            getIndicatorNumItems(SCConst.numSeekingVMMC_ServIndMstID, indInfo, mstIDsObj),
                            yearIdx,
                            monthIdx
                        ),

                        infoSources: getArrayOfValues(
                            SCConst.infoSourcesIndMstID,
                            response.infoSourcesObjList,
                            getIndicatorNumItems(SCConst.infoSourcesIndMstID, indInfo, mstIDsObj),
                            yearIdx,
                            monthIdx
                        ),
                    },

                    STIs_HIV: {
                        STIPos: getValue(SCConst.STIPosIndMstID, response.STIPosObjList, yearIdx, monthIdx),

                        STITreatCircum: getValue(
                            SCConst.STITreatCircumIndMstID,
                            response.STITreatCircumObjList,
                            yearIdx,
                            monthIdx
                        ),

                        enrolledCAndT: getValue(
                            SCConst.enrolledCAndTIndMstID,
                            response.enrolledCAndTObjList,
                            yearIdx,
                            monthIdx
                        ),

                        HIVTestDone: getValue(
                            SCConst.HIVTestDoneIndMstID,
                            response.HIVTestDoneObjList,
                            yearIdx,
                            monthIdx
                        ),

                        HIVPos: getValue(SCConst.HIVPosIndMstID, response.HIVPosObjList, yearIdx, monthIdx),
                    },
                }; // siteObj

                /* Clone the arrays. */
                let targets = this.state.target.map((x) => x.map((y) => y));
                let capacity = this.state.persFac.map((x) => x.map((y) => y));
                let VMMCDone = this.state.VMMCsPerformed.map((x) => x.map((y) => y));
                let demand = this.state.demand.map((x) => x.map((y) => y));

                /**********************   Targets tab *******************************/

                let dataCol = 1;
                let row = 0;

                targets[row][dataCol] = monthToDisplay;
                row++;
                targets[row][dataCol] = getInputValue(siteObj.VMMC_ServDeliv.targNumCircum);

                /***********************   Personnel and facility tab   ***************/

                row = 1;

                capacity[row][dataCol] = siteObj.personnel.numSurgBeds;
                row++;
                /* currNumSurgCapStaff is actually made up of three different indicators. */
                capacity[row][dataCol] = siteObj.personnel.currNumSurgCapStaff[1];
                row++;
                capacity[row][dataCol] = siteObj.personnel.currNumSurgCapStaff[2];
                row++;
                capacity[row][dataCol] = siteObj.personnel.currNumSurgCapStaff[3];
                row++;
                capacity[row][dataCol] = siteObj.demand.currNumMobil;
                row++;
                capacity[row][dataCol] = siteObj.personnel.currNumCouns;

                /* Convert -1s to blanks. Blanks mean no data. */
                for (let i = 1; i < capacity.length; i++) {
                    capacity[i][dataCol] = getInputValue(capacity[i][1]);
                }

                /***********************   Performance tab   ***************/

                dataCol = 2;
                row = 0;

                VMMCDone[row][dataCol] = monthToDisplay;
                row++;

                const VMMCsPerformedStartRow = row;

                let numVMMC_AgeGroups = getIndicatorNumItems(SCConst.VMMC_DoneIndMstID, indInfo, mstIDsObj);

                for (let i = 1; i <= numVMMC_AgeGroups; i++) {
                    VMMCDone[row][dataCol] = siteObj.VMMC_ServDeliv.VMMC_Done[i];
                    row++;
                }

                const VMMCsPerformedTotalRow = row;

                // total, done after converting -1s to blanks below
                row++;
                VMMCDone[row][dataCol] = siteObj.personnel.daysOfOp;
                row++;

                const numFollowUpRates = getIndicatorNumItems(SCConst.followUpIndMstID, indInfo, mstIDsObj);

                for (let i = 1; i <= numFollowUpRates; i++) {
                    VMMCDone[row][dataCol] = siteObj.VMMC_ServDeliv.followUp[i];
                    row++;
                }

                const numAdversEventTypes = getIndicatorNumItems(SCConst.adverseEventsIndMstID, indInfo, mstIDsObj);

                for (let i = 1; i <= numAdversEventTypes; i++) {
                    VMMCDone[row][dataCol] = siteObj.VMMC_ServDeliv.adverseEvents[i];
                    row++;
                }

                VMMCDone[row][dataCol] = siteObj.STIs_HIV.STIPos;
                row++;
                VMMCDone[row][dataCol] = siteObj.STIs_HIV.STITreatCircum;
                row++;
                VMMCDone[row][dataCol] = siteObj.STIs_HIV.HIVTestDone;
                row++;
                VMMCDone[row][dataCol] = siteObj.STIs_HIV.HIVPos;
                row++;
                VMMCDone[row][dataCol] = siteObj.STIs_HIV.enrolledCAndT;

                /* Convert -1s to blanks. Blanks mean no data. */
                for (let i = 1; i < VMMCDone.length; i++) {
                    VMMCDone[i][dataCol] = getInputValue(VMMCDone[i][dataCol]);
                }

                /* Set total, ignoring blanks. If we accidentally add a blank to a number,
                   we'll start forming a string instead (ex: 1 + '' + 2 = 12, not 3. */
                VMMCDone[VMMCsPerformedTotalRow][dataCol] = 0;
                for (let r = VMMCsPerformedStartRow; r <= VMMCsPerformedTotalRow - 1; r++) {
                    if (VMMCDone[r][dataCol] !== "") {
                        VMMCDone[VMMCsPerformedTotalRow][dataCol] =
                            VMMCDone[VMMCsPerformedTotalRow][dataCol] + VMMCDone[r][dataCol];
                    }
                }

                /***********************   Demand tab   ***************/

                row = 0;

                demand[row][dataCol] = monthToDisplay;
                row++;

                const numReachedByMobilStartRow = row;

                numVMMC_AgeGroups = getIndicatorNumItems(SCConst.numReachedByMobilIndMstID, indInfo, mstIDsObj);

                for (let i = 1; i <= numVMMC_AgeGroups; i++) {
                    demand[row][dataCol] = siteObj.demand.numReachedByMobil[i];
                    row++;
                }

                const numReachedByMobilTotalRow = row;
                // total, done after converting -1s to blanks below
                row++;

                const numSeekingVMMC_ServStartRow = row;

                numVMMC_AgeGroups = getIndicatorNumItems(SCConst.numSeekingVMMC_ServIndMstID, indInfo, mstIDsObj);

                for (let i = 1; i <= numVMMC_AgeGroups; i++) {
                    demand[row][dataCol] = siteObj.demand.numSeekingVMMC_Serv[i];
                    row++;
                }

                const numSeekingVMMC_ServTotalRow = row;
                // total, done after converting -1s to blanks below
                row++;

                const inforSourcesStartRow = row;

                const numInfoSources = getIndicatorNumItems(SCConst.infoSourcesIndMstID, indInfo, mstIDsObj);

                for (let i = 1; i <= numInfoSources; i++) {
                    demand[row][dataCol] = siteObj.demand.infoSources[i];
                    row++;
                }

                const infoSourcesTotalRow = row;

                /* Convert -1s to blanks. Blanks mean no data. */
                for (let row = 1; row < demand.length; row++) {
                    demand[row][dataCol] = getInputValue(demand[row][dataCol]);
                }

                /* Set total, ignoring blanks. If we accidentally add a blank to a number,
                   we'll start forming a string instead (ex: 1 + '' + 2 = 12, not 3. */
                demand[numReachedByMobilTotalRow][dataCol] = 0;
                for (let row = numReachedByMobilStartRow; row <= numReachedByMobilTotalRow - 1; row++) {
                    if (demand[row][dataCol] !== "") {
                        demand[numReachedByMobilTotalRow][dataCol] =
                            demand[numReachedByMobilTotalRow][dataCol] + demand[row][dataCol];
                    }
                }

                demand[numSeekingVMMC_ServTotalRow][dataCol] = 0;
                for (let row = numSeekingVMMC_ServStartRow; row <= numSeekingVMMC_ServTotalRow - 1; row++) {
                    if (demand[row][dataCol] !== "") {
                        demand[numSeekingVMMC_ServTotalRow][dataCol] =
                            demand[numSeekingVMMC_ServTotalRow][dataCol] + demand[row][dataCol];
                    }
                }

                demand[infoSourcesTotalRow][dataCol] = 0;
                for (let row = inforSourcesStartRow; row <= infoSourcesTotalRow - 1; row++) {
                    if (demand[row][dataCol] !== "") {
                        demand[infoSourcesTotalRow][dataCol] =
                            demand[infoSourcesTotalRow][dataCol] + demand[row][dataCol];
                    }
                }

                this.setState({
                    GeoIdx: siteObj.setup.geoType - 1,
                    ServiceDeliveryModesIdx: siteObj.setup.servDelivMode - 1,
                    PEPFARCategoriesIdx: siteObj.characteristics.PEPFAR_Cat - 1,
                    VMMCCategoriesIdx: siteObj.characteristics.VMMC_Cat - 1,
                    DREAMSIdx: siteObj.characteristics.DREAMS_Cat - 1,
                    USGAgenciesIdx: siteObj.characteristics.USG_Agency - 1,
                    ImplementingPartnersIdx: siteObj.characteristics.impPartner - 1,
                    OwnershipIdx: siteObj.characteristics.ownershipType - 1,
                    moveIdx: siteObj.characteristics.moveServDeliv ? 0 : 1,
                    taskShiftingIdx: siteObj.characteristics.taskShiftServDeliv ? 0 : 1,
                    target: targets,
                    persFac: capacity,
                    VMMCsPerformed: VMMCDone,
                    demand: demand,
                });
            };

            if (siteMstID !== -1) {
                SCService.getSiteObj(
                    siteMstID,
                    (response) => {
                        setSiteState(response);
                    },
                    (e) => {
                        alert("Error retrieving site data. Server message: " + e);
                        console.error(e);
                    }
                );
            }
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onSubmitBtnClick = () => {
        try {
            let sheet = [];

            const catInfo = this.props.catInfo;
            const indInfo = this.props.indInfo;
            const mstIDsObj = this.props.mstIDsObj;
            const dateInfo = this.state.dateInfo;
            const dateIdx = this.state.dateIdx;
            const siteCharByTimeInfo = this.props.siteCharByTimeInfo;

            const monthIdx = dateInfo[dateIdx].monthIdx;
            const yearName = dateInfo[dateIdx].year;

            let row = [];
            //let countries = this.props.countryOL;
            //let countryObj   = countries.length > 0         ? countries[this.state.countryIdx] : null;
            let countryObj = this.state.countryObj;
            let provinceObj = countryObj.provinces.length > 0 ? countryObj.provinces[this.state.provinceIdx] : null;
            let SNU_Obj = provinceObj.snus.length > 0 ? provinceObj.snus[this.state.snuIdx] : null;
            let siteObj = SNU_Obj.sites.length > 0 ? SNU_Obj.sites[this.state.siteIdx] : null;

            const countryName = countryObj.name === "undefined" ? "N/A" : countryObj.name;
            const provinceName = provinceObj.name === "undefined" ? "N/A" : provinceObj.name;
            const SNU_Name = SNU_Obj.name === "undefined" ? "N/A" : SNU_Obj.name;
            const siteName = siteObj.name === "undefined" ? "N/A" : siteObj.name;

            const countryMstID = countryObj.mstID === "undefined" ? -1 : countryObj.mstID;
            const provinceMstID = provinceObj.mstID === "undefined" ? -1 : provinceObj.mstID;
            const SNU_MstID = SNU_Obj.mstID === "undefined" ? -1 : SNU_Obj.mstID;
            const siteMstID = siteObj.mstID === "undefined" ? -1 : siteObj.mstID;

            const geoType = this.state.GeoIdx + 1;
            const servDelivMode = this.state.ServiceDeliveryModesIdx + 1;
            const PEPFAR_Cat = this.state.PEPFARCategoriesIdx + 1;
            const VMMC_Cat = this.state.VMMCCategoriesIdx + 1;
            const DREAMS_Cat = this.state.DREAMSIdx + 1;
            const USG_Agency = this.state.USGAgenciesIdx + 1;
            const impPartner = this.state.ImplementingPartnersIdx + 1;
            const ownershipType = this.state.OwnershipIdx + 1;
            const moveServDeliv = this.state.moveIdx;
            const taskShift = this.state.taskShiftingIdx;

            const geoTypeNames = siteCharByTimeInfo[SCConst.geoTypeNames];
            const servDelivModeNames = siteCharByTimeInfo[SCConst.servDelivModeNames];
            const PEPFAR_CatNames = siteCharByTimeInfo[SCConst.PEPFAR_CatNames];
            const VMMC_CatNames = siteCharByTimeInfo[SCConst.VMMC_CatNames];
            const DREAMS_CatNames = siteCharByTimeInfo[SCConst.DREAMS_CatNames];
            const ownershipTypeNames = siteCharByTimeInfo[SCConst.ownershipTypeNames];
            const USG_AgencyNames = siteCharByTimeInfo[SCConst.USG_AgencyNames];
            const impPartnerNames = siteCharByTimeInfo[SCConst.impPartnerNames];

            const geoTypeMstIDs = siteCharByTimeInfo[SCConst.geoTypeMstIDs];
            const servDelivModeMstIDs = siteCharByTimeInfo[SCConst.servDelivModeMstIDs];
            const PEPFAR_CatMstIDs = siteCharByTimeInfo[SCConst.PEPFAR_CatMstIDs];
            const VMMC_CatMstIDs = siteCharByTimeInfo[SCConst.VMMC_CatMstIDs];
            const DREAMS_CatMstIDs = siteCharByTimeInfo[SCConst.DREAMS_CatMstIDs];
            const ownershipTypeMstIDs = siteCharByTimeInfo[SCConst.ownershipTypeMstIDs];
            const USG_AgencyMstIDs = siteCharByTimeInfo[SCConst.USG_AgencyMstIDs];
            const impPartnerMstIDs = siteCharByTimeInfo[SCConst.impPartnerMstIDs];

            //----------------------------------------------------------

            row = [];
            row.push("<Level>");
            row.push("<Level Name>");
            row.push("<Level Master ID>");
            sheet.push(row);

            row = [];
            row.push("<Country>");
            //row.push(countries[this.state.countryIdx].name);
            //row.push(countries[this.state.countryIdx].mstID);
            row.push(countryName);
            row.push(countryMstID);
            sheet.push(row);

            row = [];
            row.push("<Province>");
            row.push(provinceName);
            row.push(provinceMstID);
            sheet.push(row);

            row = [];
            row.push("<SNU>");
            row.push(SNU_Name);
            row.push(SNU_MstID);
            sheet.push(row);

            row = [];
            row.push("<Site>");
            row.push(siteName);
            row.push(siteMstID);
            sheet.push(row);

            row = [];
            sheet.push(row);

            row = [];
            row.push("<Year>");
            row.push(yearName);
            sheet.push(row);

            row = [];
            row.push("<Month>");
            row.push(monthIdx);
            sheet.push(row);

            //----------------------------------------------------------

            row = [];
            sheet.push(row);

            row = ["", "", "", "", ""];
            row.push("<Value>");
            row.push("");
            row.push("<Indicator Master ID>");
            row.push("<Item Master ID>");
            sheet.push(row);

            row = [];
            sheet.push(row);

            //----------------------------------------------------------
            row = [];
            row.push(getCategoryName(SCConst.cat_CharMstID, catInfo, mstIDsObj));
            sheet.push(row);

            row = ["", "", "", ""];
            row.push(getIndicatorName(SCConst.geoTypeIndMstID, indInfo, mstIDsObj));
            row.push(geoTypeNames[geoType]);
            row.push("");
            row.push(SCConst.geoTypeIndMstID);
            row.push(geoTypeMstIDs[geoType]);
            sheet.push(row);

            row = ["", "", "", ""];
            row.push(getIndicatorName(SCConst.servDelivModeIndMstID, indInfo, mstIDsObj));
            row.push(servDelivModeNames[servDelivMode]);
            row.push("");
            row.push(SCConst.servDelivModeIndMstID);
            row.push(servDelivModeMstIDs[servDelivMode]);
            sheet.push(row);

            row = ["", "", "", ""];
            row.push(getIndicatorName(SCConst.PEPFAR_CatIndMstID, indInfo, mstIDsObj));
            row.push(PEPFAR_CatNames[PEPFAR_Cat]);
            row.push("");
            row.push(SCConst.PEPFAR_CatIndMstID);
            row.push(PEPFAR_CatMstIDs[PEPFAR_Cat]);
            sheet.push(row);

            row = ["", "", "", ""];
            row.push(getIndicatorName(SCConst.VMMC_CatIndMstID, indInfo, mstIDsObj));
            row.push(VMMC_CatNames[VMMC_Cat]);
            row.push("");
            row.push(SCConst.VMMC_CatIndMstID);
            row.push(VMMC_CatMstIDs[VMMC_Cat]);
            sheet.push(row);

            row = ["", "", "", ""];
            row.push(getIndicatorName(SCConst.DREAMS_CatIndMstID, indInfo, mstIDsObj));
            row.push(DREAMS_CatNames[DREAMS_Cat]);
            row.push("");
            row.push(SCConst.DREAMS_CatIndMstID);
            row.push(DREAMS_CatMstIDs[DREAMS_Cat]);
            sheet.push(row);

            row = ["", "", "", ""];
            row.push(getIndicatorName(SCConst.USG_AgencyIndMstID, indInfo, mstIDsObj));
            row.push(USG_AgencyNames[USG_Agency]);
            row.push("");
            row.push(SCConst.USG_AgencyIndMstID);
            row.push(USG_AgencyMstIDs[USG_Agency]);
            sheet.push(row);

            row = ["", "", "", ""];
            row.push(getIndicatorName(SCConst.impPartnerIndMstID, indInfo, mstIDsObj));
            row.push(impPartnerNames[impPartner]);
            row.push("");
            row.push(SCConst.impPartnerIndMstID);
            row.push(impPartnerMstIDs[impPartner]);
            sheet.push(row);

            row = ["", "", "", ""];
            row.push(getIndicatorName(SCConst.ownershipTypeIndMstID, indInfo, mstIDsObj));
            row.push(ownershipTypeNames[ownershipType]);
            row.push("");
            row.push(SCConst.ownershipTypeIndMstID);
            row.push(ownershipTypeMstIDs[ownershipType]);
            sheet.push(row);

            row = ["", "", "", ""];
            row.push(getIndicatorName(SCConst.moveServDelivIndMstID, indInfo, mstIDsObj));
            row.push(Boolean(moveServDeliv));
            row.push("");
            row.push(SCConst.moveServDelivIndMstID);
            row.push(moveServDeliv);
            sheet.push(row);

            row = ["", "", "", ""];
            row.push(getIndicatorName(SCConst.taskShiftServDelivIndMstID, indInfo, mstIDsObj));
            row.push(Boolean(taskShift));
            row.push("");
            row.push(SCConst.taskShiftServDelivIndMstID);
            row.push(taskShift);
            sheet.push(row);

            row = [];
            sheet.push(row);

            //----------------------------------------------------------

            row = [];

            row.push("Target");
            sheet.push(row);

            for (let r = 0; r < this.state.target.length; r++) {
                row = ["", "", "", ""];
                row.push(this.state.target[r]);
                row.push("");
                row.push(this.state.targetIndItemMstIDs[r]);
                sheet.push(row);
            }

            //----------------------------------------------------------

            row = [];
            sheet.push(row);

            row = [];
            row.push(getCategoryName(SCConst.cat_PersFacMstID, catInfo, mstIDsObj));
            sheet.push(row);

            for (let r = 0; r < this.state.persFac.length; r++) {
                row = ["", "", "", ""];
                row.push(this.state.persFac[r]);
                row.push("");
                row.push(this.state.persFacIndItemMstIDs[r]);
                sheet.push(row);
            }

            //----------------------------------------------------------

            row = [];
            sheet.push(row);

            row = [];
            row.push(getCategoryName(SCConst.cat_SiteProdMstID, catInfo, mstIDsObj));
            sheet.push(row);

            for (let r = 0; r < this.state.VMMCsPerformed.length; r++) {
                row = ["", "", ""];
                row.push(this.state.VMMCsPerformed[r]);
                row.push("");
                row.push(this.state.VMMCsPerformedIndItemMstIDs[r]);
                sheet.push(row);
            }

            //----------------------------------------------------------

            row = [];
            sheet.push(row);

            row = [];
            row.push(getCategoryName(SCConst.cat_DemandMstID, catInfo, mstIDsObj));
            sheet.push(row);

            for (let r = 0; r < this.state.demand.length; r++) {
                row = ["", "", ""];
                row.push(this.state.demand[r]);
                row.push("");
                row.push(this.state.demandIndItemMstIDs[r]);
                sheet.push(row);
            }

            var lineArray = [];
            sheet.forEach(function (infoArray, index) {
                var line = infoArray.join(",");
                line = line.replace("#", "Number");
                //lineArray.push(index == 0 ? "data:text/csv;charset=utf-8," + line : line);
                lineArray.push(line);
            });
            var csvContent = lineArray.join("\n");

            // var encodedUri = encodeURI(csvContent);
            // var link = document.createElement("a");
            // link.setAttribute("href", encodedUri);
            // link.setAttribute("download", "template.csv");
            //
            // document.body.appendChild(link); // Required for FF
            // link.click();
            // document.body.removeChild(link);
            //
            // console.log(sheet);
            // console.log(csvContent);

            const today = new Date();
            const date = getMonthName(today.getMonth()) + " " + today.getDate() + ", " + today.getFullYear();
            const time = formatTimeAmPm(today);
            const dateSubmitted = date + " at " + time;

            SCService.sendEmail(
                "SiteData.csv",
                csvContent,
                countryName,
                provinceName,
                SNU_Name,
                siteName,
                dateSubmitted,
                (response) => {
                    alert("Data has been submitted for approval.");
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onDataEntryOptionRadioGroupChange = (value, info) => {
        try {
            this.setState({
                dataEntryOption: value + 1,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onDownloadTemplateBtnClick = () => {
        try {
            const configObj = this.props.config;
            const sitesIncludedBoolArr = configObj[SCConst.sitesIncluded];
            const successFn = (result) => {
                console.log(API_URL_BASE + "/" + result);
                // const templateWindow = window.open(API_URL_BASE + "/" + result, "", "", true);
                //
                // if (templateWindow === null) {
                //     alert("Could not open window for template.");
                // }

                let a = document.createElement("a");
                a.href = API_URL_BASE + "/" + result;
                a.download = "Template.xlsx";
                document.body.appendChild(a);
                a.click();
                a.remove();

                this.setState({
                    downloadingTemplateBool: false,
                });
            };
            const errorFn = () => {
                alert("An error occurred while trying to download the data template.");

                this.setState({
                    downloadingTemplateBool: false,
                });
            };

            this.setState(
                {
                    downloadingTemplateBool: true,
                },
                () => {
                    SCService.getDataTemplate(sitesIncludedBoolArr, successFn, errorFn);
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /*
    *
    *     onDownloadTemplateBtnClick = () => {

        try {
            const selectedCountryCodeInt = this.props.selectedCountryCode;
            const configObj = this.props.config;
            const sitesIncludedBoolArr = configObj[SCConst.sitesIncluded];
            const successFn = (result)=> {
                console.log(API_URL_BASE + "/" + result);
                window.open(API_URL_BASE + "/" + result);
            };
            const errorFn = () => {
                alert("An error occurred while trying to download the data template.");
            };

            SCService.getDataTemplate(
                sitesIncludedBoolArr, successFn, errorFn);
        }
        catch (exception) {
            alert(exception.name + ': ' + exception.message);
        }

    };
    *
    *
    *                 const templateWindow = setTimeout(() => {
                    window.open(API_URL_BASE + "/" + result);
                }, 5000);
    * */

    /* Brings up dialog for the user to choose an XLSX file. Attached to Upload button. */
    onUploadTemplateBtnClick = () => {
        try {
            this.refs.importUploader.click();
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /* Fires when the user clicks ok, etc. in the dialog. */
    onUploadTemplate = (event) => {
        try {
            // let uploadUserData = (file) => {
            //     const today = new Date();
            //     const date =
            //         getMonthName(today.getMonth()) +  ' ' +
            //         today.getDate() + ', ' +
            //         today.getFullYear();
            //     const time = formatTimeAmPm(today);
            //     const dateSubmitted = date + ' at ' + time;
            //
            //     SCService.uploadUserData('SiteData.csv', file,
            //         dateSubmitted,
            //         (response) => {},
            //         alert('Data has been submitted for approval.'));
            // };

            let file = event.target.files[0];

            console.log("Uploading XLSX file: " + file);

            SCService.upload(
                file,
                GBConst.GB_SC,
                (result) => {
                    console.log(result);
                    alert("Data has been submitted for approval.");
                },
                () => {
                    alert("Failed to upload file.");
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        try {
            if (this.state.loading) {
                return <div>Loading</div>;
            }

            const styles = {
                inner: {
                    position: "absolute",
                    top: "66px",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    overflow: "auto",
                },
                red: {
                    color: "red",
                },
            };

            /* Props - to shorten code below. */
            const catInfo = this.props.catInfo;
            const mstIDsObj = this.props.mstIDsObj;
            const indInfo = this.props.indInfo;

            /* State - to shorten code below. */
            const countryObj = this.state.countryObj;
            const dates = this.state.dateNames;
            const dateIdx = this.state.dateIdx;
            const downloadingTemplateBool = this.state.downloadingTemplateBool;
            const provinceIdx = this.state.provinceIdx;
            const SNU_Idx = this.state.snuIdx;
            const siteIdx = this.state.siteIdx;
            const dataEntryOption = this.state.dataEntryOption;

            const provinceObj =
                countryObj === null ? null : countryObj.provinces.length > 0 ? countryObj.provinces[provinceIdx] : null;
            const SNU_Obj =
                provinceObj === null ? null : provinceObj.snus.length > 0 ? provinceObj.snus[SNU_Idx] : null;

            //const countryNames = countries === null ? []   : countries.map(x => x.name);
            const provinceNames = countryObj === null ? [] : countryObj.provinces.map((x) => x.name);
            const snuNames = provinceObj === null ? [] : provinceObj.snus.map((x) => x.name);
            const siteNames = SNU_Obj === null ? [] : SNU_Obj.sites.map((x) => x.name);

            const targetsValues = JSON.parse(JSON.stringify(this.state.target));
            const capacityValues = JSON.parse(JSON.stringify(this.state.persFac));
            const VMMCsDoneValues = JSON.parse(JSON.stringify(this.state.VMMCsPerformed));
            const demandValues = JSON.parse(JSON.stringify(this.state.demand));

            const noSitesToShowBool = siteNames.length === 0;
            const dataEntryOnlineBool = dataEntryOption === dataEntryOnlineNum;

            let downloadTemplateBtn = null;
            let uploadTemplateBtn = null;
            let inputDialog = null;

            if (!dataEntryOnlineBool) {
                downloadTemplateBtn = (
                    <TButton
                        caption="Download template"
                        containerStyle={{ float: "right" }}
                        style={{ marginTop: 15, display: "inline-block" }}
                        onClick={this.onDownloadTemplateBtnClick}
                    />
                );

                uploadTemplateBtn = (
                    <TButton
                        caption="Upload template"
                        containerStyle={{ float: "right" }}
                        style={{ marginTop: 15, display: "inline-block" }}
                        onClick={this.onUploadTemplateBtnClick}
                    />
                );

                inputDialog = (
                    <input
                        type="file"
                        accept=".xlsx"
                        ref="importUploader"
                        style={{ display: "none" }}
                        onChange={this.onUploadTemplate}
                    />
                );
            }

            const dataEntryOptionRadioGroup = (
                <TRadioGroup
                    row={true}
                    caption={"Data entry mode"}
                    itemIndex={dataEntryOption - 1}
                    items={["Online", "Offline"]}
                    handleChange={this.onDataEntryOptionRadioGroupChange}
                    info={[
                        [dataEntryOptionStr, dataEntryOnlineNum],
                        [dataEntryOptionStr, dataEntryOfflineNum],
                    ]}
                />
            );

            const dataEntryOptionDiv = (
                <div>
                    {dataEntryOptionRadioGroup}
                    {uploadTemplateBtn}
                    {inputDialog}
                    {downloadTemplateBtn}
                </div>
            );

            /* Guessing that the drawer heading is created here instead of
               App.js like the other drawers because of the onSubmitBtnClick. There is
               lots of data-entry-specific stuff happening there that we don't have access
               to in App.js. The DrawerHeader is hidden in App.js by passing headerVisible =
               false into TDrawerForm for the SCDataEntryDrawer. Then it's created here
               instead. */
            const drawerHeader = (
                <TDrawerHeader
                    title="Data entry"
                    showSaveBtnBool={dataEntryOnlineBool}
                    onSave={this.onSubmitBtnClick}
                    onClose={this.onClose}
                    saveBtnCaption="Submit"
                />
            );

            let provinceComboBox = null;
            let SNU_ComboBox = null;
            let siteComboBox = null;
            let monthComboBox = null;
            let selectSiteDiv = null;
            let tabs = null;
            let locationsSection = null;

            if (dataEntryOnlineBool) {
                provinceComboBox = (
                    <SCComboBoxProvinces
                        names={provinceNames}
                        itemIndex={provinceIdx}
                        onChange={this.onProvinceChange}
                    />
                );

                SNU_ComboBox = (
                    <SCComboBoxSNUs
                        names={snuNames}
                        itemIndex={SNU_Idx}
                        onChange={this.onSNUChange}
                    />
                );

                siteComboBox = (
                    <SCComboBoxSites
                        names={siteNames}
                        itemIndex={siteIdx}
                        onChange={this.onSiteChange}
                    />
                );

                monthComboBox = (
                    <SCComboBoxMonths
                        names={dates}
                        itemIndex={dateIdx}
                        onChange={this.onDateChange}
                    />
                );

                if (noSitesToShowBool) {
                    selectSiteDiv = <div style={styles.red}>Please select a site to continue.</div>;
                } else {
                    const characteristicsTemplate = (
                        <SCCharacteristicComboBoxes
                            catInfo={this.props.catInfo}
                            mstIDsObj={this.props.mstIDsObj}
                            indInfo={this.props.indInfo}
                            siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                            GeoItemIndex={this.state.GeoIdx}
                            ServiceDeliveryModesItemIndex={this.state.ServiceDeliveryModesIdx}
                            PEPFARCategoriesItemIndex={this.state.PEPFARCategoriesIdx}
                            VMMCCategoriesItemIndex={this.state.VMMCCategoriesIdx}
                            DREAMSItemIndex={this.state.DREAMSIdx}
                            USGAgenciesItemIndex={this.state.USGAgenciesIdx}
                            ImplementingPartnersItemIndex={this.state.ImplementingPartnersIdx}
                            OwnershipItemIndex={this.state.OwnershipIdx}
                            MoveIdx={this.state.moveIdx}
                            TaskShiftingIdx={this.state.taskShiftingIdx}
                            onGeoChange={this.onGeoChange}
                            onPEPFARCategoriesChange={this.onPEPFARCategoriesChange}
                            onVMMCCategoriesChange={this.onVMMCCategoriesChange}
                            onDREAMSChange={this.onDREAMSChange}
                            onUSGAgencieChange={this.onUSGAgencieChange}
                            onImplementingPartnersChange={this.onImplementingPartnersChange}
                            onServiceDeliveryModesChange={this.onServiceDeliveryModesChange}
                            onOwnershipChange={this.onOwnershipChange}
                            onMoveChange={this.onMoveChange}
                            onTaskShiftingChange={this.onTaskShiftingChange}
                        />
                    );

                    const targetTemplate = (
                        <SCTargetTable
                            catInfo={catInfo}
                            mstIDsObj={mstIDsObj}
                            value={targetsValues}
                            onChange={this.onTargetsChange}
                        />
                    );

                    const persFacTemplate = (
                        <SCPersFacTable
                            catInfo={catInfo}
                            mstIDsObj={mstIDsObj}
                            value={capacityValues}
                            onChange={this.onCapacityChange}
                        />
                    );

                    const productivityTemplate = (
                        <SCProductivityTable
                            catInfo={catInfo}
                            onChange={this.onVMMCDoneChange}
                            indInfo={indInfo}
                            mstIDsObj={mstIDsObj}
                            value={VMMCsDoneValues}
                        />
                    );

                    const demandTemplate = (
                        <SCDemandTable
                            catInfo={catInfo}
                            onChange={this.onDemandChange}
                            indInfo={indInfo}
                            mstIDsObj={mstIDsObj}
                            value={demandValues}
                        />
                    );

                    tabs = (
                        <TTabs2
                            tabTitles={[
                                getCategoryName(SCConst.cat_CharMstID, catInfo, mstIDsObj),
                                "Target",
                                getCategoryName(SCConst.cat_PersFacMstID, catInfo, mstIDsObj),
                                "Performance",
                                getCategoryName(SCConst.cat_DemandMstID, catInfo, mstIDsObj),
                            ]}
                            tabContents={[
                                characteristicsTemplate,
                                targetTemplate,
                                persFacTemplate,
                                productivityTemplate,
                                demandTemplate,
                            ]}
                        />
                    );
                }
            } else {
                const locationsSelector = (
                    <SCLocationsSelector
                        config={this.props.config}
                        configExtra={this.props.configExtra}
                        selectedCountryCode={this.props.selectedCountryCode}
                        countries={this.props.countries}
                        siteInfo={this.props.siteInfo}
                        mstIDsObj={this.props.mstIDsObj}
                    />
                );

                locationsSection = (
                    <section style={{ width: 900, display: "inline-block" }}>
                        <h5>
                            Adjust the sites to appear in the data template. When you are finished, click the 'Download
                            template' button above to save the template to your computer. After filling out the
                            template, click the 'Upload template' button above to submit your data for approval.
                        </h5>
                        <h5></h5>
                        <h5>Click a province or SNU to view all SNUs or sites it contains, respectively.</h5>
                        {locationsSelector}
                    </section>
                );
            }

            let commWithServerDialog = null;

            if (downloadingTemplateBool) {
                commWithServerDialog = (
                    <TDialog
                        caption={"Communicating with server..."}
                        icon={
                            <TWifiAnimation
                                style={{
                                    marginRight: "20px",
                                    float: "left",
                                }}
                            />
                        }
                        visible={true}
                        style={{
                            width: "370px",
                        }}
                    />
                );
            }

            return (
                <div>
                    {drawerHeader}

                    <div style={styles.inner}>
                        <div className="innerPage">
                            {dataEntryOptionDiv}
                            <Divider style={{ marginTop: 10, marginBottom: 10, display: "inline-block" }} />
                            {provinceComboBox}
                            {SNU_ComboBox}
                            {siteComboBox}
                            {monthComboBox}
                            {selectSiteDiv}
                            {tabs}
                            {locationsSection}
                            {commWithServerDialog}
                        </div>
                    </div>
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"SCDataEntryDrawerDiv"}
                    key={"SCDataEntryDrawerDiv"}
                >
                    <h3 key={"SCDataEntryDrawerDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCDataEntryDrawer;
